import api from './api';

const transactionService = {
  // Get all transactions with filters
  getTransactions: async (params = {}) => {
    const response = await api.get('/transactions', { params });
    return response.data;
  },

  // Get single transaction
  getTransaction: async (id) => {
    const response = await api.get(`/transactions/${id}`);
    return response.data;
  },

  // Approve a single transaction with provider
  approveTransaction: async (id, provider) => {
    const response = await api.post(`/transactions/${id}/approve`, { provider });
    return response.data;
  },

  // Bulk approve transactions
  bulkApproveTransactions: async (transactionIds) => {
    const response = await api.post('/transactions/bulk-approve', { transaction_ids: transactionIds });
    return response.data;
  },

  // Reject a single transaction
  rejectTransaction: async (id, reason) => {
    const response = await api.post(`/transactions/${id}/reject`, { reason });
    return response.data;
  },

  // Bulk reject transactions
  bulkRejectTransactions: async (transactionIds, reason) => {
    const response = await api.post('/transactions/bulk-reject', { transaction_ids: transactionIds, reason });
    return response.data;
  },

  // Export transactions to CSV
  exportTransactions: async (params = {}) => {
    const response = await api.get('/transactions/export', {
      params,
      responseType: 'blob'
    });

    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `transactions_${Date.now()}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  // Get transaction stats
  getTransactionStats: async (projectId) => {
    const params = projectId ? { project_id: projectId } : {};
    const response = await api.get('/transactions/stats', { params });
    return response.data;
  }
};

export default transactionService;
